import { UnloadedIPatientCase } from '@llx/common';

import createTanstackTableDataStore from '@/ui/TanstackTable/createTanstackTableDataStore';

const useAdminCaseListTableStore = createTanstackTableDataStore<UnloadedIPatientCase>({
  storeName: 'admin-caselist-table-store',
  defaultColumnSizing: {},
  defaultColumnSorting: [
    {
      id: 'creationDate',
      desc: false,
    },
  ],
  defaultColumnVisibility: {
    // id: false,
  },
});

export default useAdminCaseListTableStore;
